import { FC } from "react"
import s from "@pages/fid_view/styles.module.css"
import { EventContactInfoDto } from "@app/data/tribeSwaggerApi"

export interface OrganizerContentProps {
  eventContactInfoDto?: EventContactInfoDto[]
}

const OrganizerContent: FC<OrganizerContentProps> = ({ eventContactInfoDto }) => {
  if (!eventContactInfoDto || eventContactInfoDto.length === 0) return null

  const telegram = eventContactInfoDto.find(i => i.contact_type === "TELEGRAM")?.contact
  const whatsapp = eventContactInfoDto.find(i => i.contact_type === "WHATSAPP")?.contact
  const phone = eventContactInfoDto.find(i => i.contact_type === "PHONE")?.contact
  const url = eventContactInfoDto.find(i => i.contact_type === "URL")?.contact

  const hasAny = telegram || whatsapp || phone || url
  if (!hasAny) return null

  const tgHandle = telegram?.startsWith("@") ? telegram : telegram ? `@${telegram}` : null
  const tgLink = tgHandle ? `https://t.me/${tgHandle.replace("@", "")}` : null
  const waLink = whatsapp ? `https://wa.me/${whatsapp.replace(/[^\d]/g, "")}` : null
  const telLink = phone ? `tel:${phone.replace(/\s/g, "")}` : null
  const siteLink = url ? (url.startsWith("http") ? url : `//${url}`) : null

  return (
    <div className={s.description_box}>
      <p style={{ fontSize: "14px", fontWeight: 600, color: "var(--secondary-text)", marginBottom: "10px" }}>
        Записаться:
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {tgLink && (
          <a href={tgLink} target="_blank" rel="noreferrer"
            style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "var(--primary-text)" }}>
            <span style={{ fontSize: "22px" }}>✈️</span>
            <span style={{ color: "var(--Schemes-Primary)", fontWeight: 500 }}>{tgHandle}</span>
          </a>
        )}
        {waLink && (
          <a href={waLink} target="_blank" rel="noreferrer"
            style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "var(--primary-text)" }}>
            <span style={{ fontSize: "22px" }}>💬</span>
            <span style={{ color: "var(--Schemes-Primary)", fontWeight: 500 }}>{whatsapp}</span>
          </a>
        )}
        {telLink && (
          <a href={telLink}
            style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "var(--primary-text)" }}>
            <span style={{ fontSize: "22px" }}>📞</span>
            <span style={{ color: "var(--Schemes-Primary)", fontWeight: 500 }}>{phone}</span>
          </a>
        )}
        {siteLink && !tgLink && !waLink && !telLink && (
          <a href={siteLink} target="_blank" rel="noreferrer"
            style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none", color: "var(--primary-text)" }}>
            <span style={{ fontSize: "22px" }}>🔗</span>
            <span style={{ color: "var(--Schemes-Primary)", fontWeight: 500 }}>Сайт организатора</span>
          </a>
        )}
      </div>
    </div>
  )
}

export default OrganizerContent
